export default __webpack_public_path__ + "static/media/telegram.8ad6ecb8.svg";